module.exports = "<i class=\"zmdi zmdi-notifications zmdi-hc-lg\"></i>\r\n<span class=\"white margin-left-8 text-14\">\r\n  {{ data }}\r\n</span>"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/snackbar/notification-snackbar/notification-snackbar.component.html
// module id = ../../../../../src/app/components/common/snackbar/notification-snackbar/notification-snackbar.component.html
// module chunks = 0